// Status
export const STATUS_TODOS = "todos";
export const STATUS_DIGITANDO = "digitando";
export const STATUS_EM_ANALISE = "em-analise";
export const STATUS_ATIVOS = "ativos";
export const STATUS_PENDENTES = "pendentes";
export const STATUS_REVISAO = "revisao";
export const STATUS_CANCELADOS = "cancelados";
